class LoyaltyRefer extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['code', 'copy']
  }

  setupListeners () {
    super.setupListeners()

    this.setAttribute('aria-busy', true)

    this.getDetails = this.getDetails.bind(this)
    this.copyToClipboard = this.copyToClipboard.bind(this)
    this.onCopyClick = this.onCopyClick.bind(this)

    document.addEventListener('swell:setup', () => {
      this.getDetails()
    })

    this.els.copy.element.addEventListener('click', this.onCopyClick)
  }

  getDetails () {
    /* eslint-disable-next-line no-undef */
    const customerDetails = swellAPI.getCustomerDetails()
    const referralCode = customerDetails.referralCode
    const referralUrl = `http://rwrd.io/${referralCode}?c`

    this.els.code.element.innerText = referralUrl

    this.setAttribute('aria-busy', false)
    this.els.copy.element.removeAttribute('disabled')
  }

  onCopyClick () {
    this.copyToClipboard()
  }

  copyToClipboard () {
    navigator.clipboard.writeText(this.els.code.element.innerText).then(() => {
      this.els.copy.element.innerText = this.els.copy.element.dataset.copied

      setTimeout(() => {
        this.els.copy.element.innerText = this.els.copy.element.dataset.copy
      }, 3000)
    })
  }
}

if (!customElements.get('loyalty-refer')) {
  customElements.define('loyalty-refer', LoyaltyRefer)
}
